module.exports = __webpack_public_path__ + "static/media/多角形_1.ff84545f.svg";